module.exports = "https://static.wmbcdn.com/uniweb/images/aa2b3c67f3b64e80c0ed87388ecb5353.svg";